import { subscribe } from "@wordpress/data";
import domReady from "@wordpress/dom-ready";
import React from "react";
import ShortcutSidebar from "../components/shortcut-sidebar/ShortcutSidebar";
import { renderer } from "./utils";

const addShortcutSidebar = () => {
	domReady(() => {
		let timeout: null | number = null;
		const unsubscribe = subscribe(() => {
			const skeleton = document.querySelector(
				".interface-interface-skeleton__body"
			);
			if (!skeleton) return;
			const root = document.createElement("div");
			root.classList.add("mzb-shortcut-sidebar");
			if (!skeleton.querySelector(".mzb-shortcut-sidebar")) {
				renderer(() => <ShortcutSidebar renderer={renderer} />, root);
				skeleton.insertBefore(root, skeleton.firstChild);
			}
			if (timeout) clearTimeout(timeout);
			timeout = setTimeout(() => {
				if (document.querySelector(".mzb-shortcut-sidebar")) {
					unsubscribe();
				}
			}, 0);
		});
	});
};

export default addShortcutSidebar;
